import React, { useCallback, useState } from "react";
import uploadImage from "../../../assets/CreateCategory/upload.svg";
import dividerImage from "../../../assets/CreateCategory/divider.svg";

import "./style.scss";
import CustomDropZone from "../../../common/CustomDropZone";
import { useDropzone } from "react-dropzone";
import Button from "../../../common/Button";
import backIcon from "../../../assets/upload-guidelines/back.svg";
import { useNavigate, useParams } from "react-router-dom";
import { message, Spin } from "antd";
import orderBatchesApi from "../../../apis/orderBatches";
import guidelinesApi from "../../../apis/guidelines";
import {
  useAddNewMarketPlaceForUser,
  useAttachMarketPlaces,
} from "../../../hooks/useOrderBatches";

const UploadGuideline = () => {
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [fileUpload, setFileUpload] = useState({});
  const [isSuccess, setIsSuccess] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [formInput, setFormInput] = useState({
    brandName: "",
    guideLineImage: "",
  });

  const { getThumbPathOfImage } = guidelinesApi;
  const { getPresignedUrlForGuidelineReferenceFileUpload } = orderBatchesApi;

  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const params = useParams();

  const navigate = useNavigate();

  const onSuccessAddNewMarketPlaceForUser = (res) => {
    if (res.status == 200) {
      message.success("MarketPlace successfully added for the User");
      // setTimeout(() => {
      //   isSubCategoryCreated();
      // });
      navigate(`/select-marketplace/${params.batchId}`);
      setImageUrl("");
      setFormInput({
        brandName: "",
        guideLineImage: "",
      });
      setErrors({});
    }
  };
  const onErrorAddNewMarketplaceForUser = () => {};

  const { mutate: addNewMarketplace } = useAddNewMarketPlaceForUser(
    onSuccessAddNewMarketPlaceForUser,
    onErrorAddNewMarketplaceForUser
  );

  const validateForm = () => {
    const newErrors = {};

    if (!formInput?.brandName?.trim()) {
      newErrors.brandName = "Brand name is required.";
    }

    if (!formInput?.guideLineImage) {
      newErrors.guideLineImage = "Image is required.";
    }

    setErrors(newErrors);
    setIsSubmitted(false);
    return Object.keys(newErrors).length === 0;
  };

  const getKeyPresignedUrl = async (file) => {
    let uploadSuccess = true;
    setIsSuccess(true);
    try {
      if (!file[0]?.name || !file[0]?.type) {
        uploadSuccess = false;
        setIsSuccess(false);
        throw new Error(
          "Invalid file detected. Ensure the file has a valid name and type."
        );
      }

      const resp = await getPresignedUrlForGuidelineReferenceFileUpload({
        filename: file[0]?.name,
        mimeType: file[0]?.type,
      });

      if (resp?.status !== 200 || !resp?.data?.key || !resp?.data?.url) {
        uploadSuccess = false;
        setIsSuccess(false);
        throw new Error("Invalid response from getPresignedUrl.");
      }

      const { key, url } = resp.data;

      const uploadResp = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": file[0]?.type, // Set the correct content type
        },
        body: file[0], // Send the file data
      });

      if (!uploadResp.ok) {
        uploadSuccess = false;
        setIsSuccess(false);

        throw new Error(`File upload failed with status: ${uploadResp.status}`);
      }

      if (uploadSuccess) {
        setIsSuccess(true);
        const addFilesPayload = key;
        setFileUpload(addFilesPayload);
        setIsSuccess(true);
        message.success("Image uploaded successfully.");
      } else {
        message.error("Some images failed to upload.");
      }
    } catch (err) {
      console.error(err);
      uploadSuccess = false;
      setIsSuccess(false);
      message.error(
        err?.response?.data?.message ||
          err.message ||
          "An error occurred during upload."
      );
    } finally {
      setIsUploadingImage(false);
    }
    return uploadSuccess;
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "application/pdf": "", // PDF files
      "application/vnd.ms-powerpoint": "", // PPT files
      "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        "", // PPTX files
      "application/msword": "", // DOC files
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        "", // DOCX files
    },
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        setImageUrl("");
        setFileUpload({});
        setFormInput((prev) => ({
          ...prev,
          guideLineImage: acceptedFiles[0],
        }));
        setIsUploadingImage(true);
        setIsDragging(false);
        getKeyPresignedUrl(acceptedFiles);
      }
    },
    multiple: false,
  });
  const onDropItems = async (file) => {
    if (file.length > 0) {
      setFormInput((prev) => ({
        ...prev,
        guideLineImage: file[0],
      }));
      setIsUploadingImage(true);
      setIsDragging(false);
      getKeyPresignedUrl(file);
    }
  };

  const handleDragEnter = useCallback((e) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    setIsDragging(false);
  }, []);

  const renderDragAndDropSection = useCallback(
    () =>
      isDragging && (
        <CustomDropZone
          dropZoneClass={"uploaded_images_row"}
          onDropItems={onDropItems}
          isShowTextOnDrag={true}
          acceptingFormates={{
            "application/pdf": "", // PDF files
            "application/vnd.ms-powerpoint": "", // PPT files
            "application/vnd.openxmlformats-officedocument.presentationml.presentation":
              "", // PPTX files
            "application/msword": "", // DOC files
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
              "", // DOCX files
          }}
          handleDragLeave={handleDragLeave}
          multiple={false}
        />
      ),
    [isDragging, onDropItems, handleDragLeave]
  );

  const onSuccessAttachMarketPlace = (res) => {
    if (res.status === 200) {
      navigate(`/sequencing/${params.batchId}`);
    } else {
      message.error("Error");
    }
  };
  const onErrorAttachMarketPlace = (err) => {
    message.error(err);
  };
  const { mutate: attachMarketPlace } = useAttachMarketPlaces(
    onSuccessAttachMarketPlace,
    onErrorAttachMarketPlace
  );

  const getUploadWrapper = () => {
    return (
      <>
        {" "}
        {isSuccess ? (
          <>
            <div className="image_preview">
              <iframe src={imageUrl} border="0" />
              <div
                className="cross-icon"
                onClick={() => {
                  setIsSuccess(false);
                  setFormInput({
                    categoryImage: "", // Clear uploaded logo
                  });
                }}
              ></div>
            </div>
          </>
        ) : (
          <div className="upload_wrapper">
            <div className="category_image">
              <img src={uploadImage} alt="" />
              <p>Drag your file(s) to start uploading</p>
            </div>
            <div className="or_image">
              <img src={dividerImage} alt="" />
            </div>
            <label className="browse">Browse files</label>
            <input
              type="file"
              accept="application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              id="file"
              onChange={(e) => {
                handleUploadImage(e.target.files);
              }}
              className="upload_more_images_btn_input"
            />
          </div>
        )}
      </>
    );
  };

  const handleUploadImage = async (file) => {
    if (file) {
      const selectedFile = file[0];
      setFormInput((prev) => ({
        ...prev,
        guideLineImage: selectedFile,
      }));
      const blobUrl = URL.createObjectURL(selectedFile);
      setImageUrl(blobUrl);
      setIsUploadingImage(true);
      getKeyPresignedUrl(file);
    }
  };

  const handleAreaClick = () => {
    document.getElementById("file")?.click();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitted(true);
      let payload = {
        name: formInput?.brandName,
        guidelineReferenceFile: fileUpload,
      };
      addNewMarketplace(payload);
    } else {
      message.error("Please fix the errors in the form.");
    }
  };

  return (
    <div className="upload_guideline" onDragEnter={handleDragEnter}>
      <div className="top_wrapper">
        <div className="brand_box">
          <form>
            <div className="form_control">
              <label>
                Brand Name <sup>*</sup>
              </label>
              <input
                placeholder="Brand Name"
                name="brandName"
                value={formInput.brandName}
                onChange={handleChange}
              />
              {errors.brandName && (
                <p className="error_message">{errors.brandName}</p>
              )}
            </div>
            <div className="form_control">
              <label>
                Upload Guidelines <sup>*</sup>
              </label>
              <div className="drop_down_wrapper" onClick={handleAreaClick}>
                <div className="item_upload_wrapper">
                  {isUploadingImage ? <Spin /> : getUploadWrapper()}
                  {renderDragAndDropSection()}
                </div>
              </div>
              {errors.brandName && (
                <p className="error_message">{errors.brandName}</p>
              )}
              <div className="extensions">
                <p className="extension_text">upload PDF, PPT, Doc files</p>
              </div>
              {errors.categoryImage && (
                <p className="error_message">{errors.categoryImage}</p>
              )}
            </div>
          </form>
        </div>
      </div>
      <div className="upload_actions">
        <button
          className="back_button"
          onClick={() => navigate(`/select-marketplace/${params.batchId}`)}
        >
          <img src={backIcon} alt="" />
        </button>
        <Button
          text="Submit"
          width="162px"
          height="55px"
          showIcon={false}
          isDisabled={!formInput.brandName || !formInput.guideLineImage}
          handleClick={handleSubmit}
        />
      </div>
    </div>
  );
};

export default UploadGuideline;
